
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n855Child = []
  var n856Child = []
  var n857Child = []
  var n858Child = []
  n858Child = n858Child.concat(text(conditionBaseT('.name')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n858 = h('label', props, n858Child)
  n857Child.push(n858)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n857 = h('div', props, n857Child)
  n856Child.push(n857)
  var n859Child = []
  var n860Child = []
  var n861Child = []
  var n862Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "_name"},{name:'value', val: shadow._name}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n862 = h('input', props, n862Child)
  n861Child.push(n862)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n861 = h('div', props, n861Child)
  n860Child.push(n861)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n860 = h('div', props, n860Child)
  n859Child.push(n860)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n859 = h('div', props, n859Child)
  n856Child.push(n859)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n856 = h('div', props, n856Child)
  n855Child.push(n856)
  n855Child = n855Child.concat(text(children))
  if(!(this.inline)) {
    var n863Child = []
    var n864Child = []
    var n865Child = []
    var n866Child = []
    n866Child = n866Child.concat(text(conditionBaseT('.save')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-primary'},{name:'onclick', val: this.finish}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n866 = h('button', props, n866Child)
    n865Child.push(n866)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n865 = h('div', props, n865Child)
    n864Child.push(n865)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n864 = h('div', props, n864Child)
    n863Child.push(n864)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n863 = h('div', props, n863Child)
    n855Child.push(n863)
  }
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'condition-form'},{name:'oninput', val: this.onInput},{name:'afterCreate', val: this.bindForm}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n855 = h('form', props, n855Child)
  n0Child.push(n855)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  